import Vue from 'vue'

/**
 * Registry of v2 destinations declared by the page currently on screen.
 *
 * Pages declare theirs with <version-banner module-key=".." v2-url=".." />;
 * root-layout renders one banner above <router-view /> from whatever is
 * registered. That keeps the banner a full-width strip at the top of the page
 * instead of squeezing it into a v-tabs or filter row, where it gets clipped.
 *
 * Several declarations can be mounted at once, because a number of these page
 * components render each other (multi-cal inside the property page, listings
 * inside the system dashboard, and 11 more). The OUTERMOST declaration wins —
 * it is the page the user actually navigated to, so a nested component must
 * not hijack the banner with its own destination.
 */
const registry = Vue.observable({ entries: [] })

let nextId = 0
export const nextVersionBannerId = () => (nextId += 1)

const indexOf = id => registry.entries.findIndex(entry => entry.id === id)

export const registerVersionBanner = entry => {
  const at = indexOf(entry.id)
  if (at === -1) registry.entries.push(entry)
  else registry.entries.splice(at, 1, entry)
}

export const unregisterVersionBanner = id => {
  const at = indexOf(id)
  if (at !== -1) registry.entries.splice(at, 1)
}

// Shallowest wins; ties resolve to the earliest registered.
export const activeVersionBanner = () =>
  registry.entries.reduce(
    (best, entry) => (best === null || entry.depth < best.depth ? entry : best),
    null
  )

export const componentDepth = vm => {
  let depth = 0
  let parent = vm.$parent
  while (parent) {
    depth += 1
    parent = parent.$parent
  }
  return depth
}
